export default __webpack_public_path__ + "static/media/oem.564578d2.png";